module.exports = __webpack_public_path__ + "static/media/dashboard 1.b979490f.svg";